import { render } from "./NotificationsList.vue?vue&type=template&id=5db8a660&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=5db8a660&lang=scss&scoped=true"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db8a660"]])

export default __exports__